import API from './api'

export const getServices = async (id, department = false) => {
  const petQuert = `pet=${id}`
  const departmentQuert = department ? `&department=${department}` : ''

  const {
    data: { results = [] },
  } = await API.get(`services?${petQuert}${departmentQuert}`)

  return results
}

export const encodeUrlParans = (content) => {
  const json = JSON.stringify(content);
  const utf8Bytes = new TextEncoder().encode(json);
  const latin1String = Array.from(utf8Bytes).map(byte => String.fromCharCode(byte)).join('');
  const base64 = btoa(latin1String);

  return encodeURIComponent(base64);
}
export const decodeUrlParans = (content) => JSON.parse(atob(decodeURIComponent(content)))

export const getServicesByName = async (id) => {
  const {
    data: { results = [] },
  } = await API.get(`services/search?text=${id}`)

  return results
}
